module.exports = __webpack_public_path__ + "img/logo.59b7abd9.png";